import React from 'react';
import { DiscoveryBlock, DiscoveryProduct } from '../../../types';
import { useDiscoverySearch, useNewProductCard, useTenantConfig } from 'hooks';
import { getFlashSaleMinEndTimeDiscovery } from 'helpers';
import { LIMIT_ITEM_PER_PAGE_PRODUCT_LIST } from 'constants/index';
import { FlashSale } from '@teko/teko-ecommerce';
import { Container } from '@teko/ds-desktop';

interface FlashSaleBlockProps {
  block: DiscoveryBlock;
}
export const FlashSaleBlock: React.FC<FlashSaleBlockProps> = ({
  block,
}: FlashSaleBlockProps) => {
  const { convertNewProductCard } = useNewProductCard();
  const { terminal } = useTenantConfig();
  const { result: flashSaleData } = useDiscoverySearch(
    block && {
      ...block.cookedData.paramsObject,
      terminalCode: terminal,
      blockId: block.id,
      itemsPerPage: LIMIT_ITEM_PER_PAGE_PRODUCT_LIST,
    },
  );
  const flsProducts = (flashSaleData?.products || []) as DiscoveryProduct[];
  return !!flsProducts?.length ? (
    <Container marginBottom="s24">
      <FlashSale
        title={block.label}
        backgroundImage={block.backgroundImageUrl}
        endAt={getFlashSaleMinEndTimeDiscovery(flsProducts)}
        productsCarousel={{
          products: flsProducts.map((product) =>
            convertNewProductCard(product),
          ),
          productsPerRow: 4,
        }}
      />
    </Container>
  ) : null;
};
